module.exports = __webpack_public_path__ + "img/red-apple.e0d8ca58.png";